import Cookies from "js-cookie";
import { React, useState, useEffect } from "react";

import Navbar from "../../../Components/Navbar";
import { fetchProfile } from "../../../utils/fetchProfile";
import { fetchUserFormatted } from "../../../utils/fetchUser";

import MapLayout from "../MapLayout";
import L from "leaflet";
import * as turf from "@turf/turf";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { Button, Box, Card, Typography } from "@mui/material";

const getFillColor = (count) => {
  return count > 1000
    ? "#073956ff"
    : count > 500
    ? "#094d75ff"
    : count > 250
    ? "#0b5b89ff"
    : count > 100
    ? "#237aacff"
    : count > 75
    ? "#449ed2ff"
    : count > 50
    ? "#62afdcff"
    : count > 10
    ? "#90ccefff"
    : "#f7fbff";
};

const styleFeatureWithTotal = (feature) => {
  const totalPlan = feature.properties.total_plan_sum || 0;

  return {
    color: "#4f4f4fff",
    weight: 1,
    fillColor: getFillColor(totalPlan),
    fillOpacity: 0.9,
  };
};
// data peta masih menggunakan yang lama (dibawah 2022)

function MapSurveyor({
  dashboardData,
  selectedSurveyId,
  selectedPeriodeId,
  selectedArea,
}) {
  const accessToken = Cookies.get("access_token") || "";
  const [isLoading, setIsLoading] = useState(false);
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [initialText, setInitialText] = useState("");
  const [dataProfile, setDataProfile] = useState([]);

  const [dataUserSurveyor, setDataUserSurveyor] = useState([]);
  const [dataUserSurveyorOptions, setDataUserSurveyorOptions] = useState([]);
  const [dataUserQcOptions, setDataUserQcOptions] = useState([]);

  const [surveyDataId, setSurveyDataId] = useState([]);

  const [filteredGeoJSONData, setFilteredGeoJSONData] = useState({
    type: "FeatureCollection",
    features: [],
  });
  const [totalPlanCount, setTotalPlanCount] = useState(0);

  const fetchGeoJSONDataInBatches = async (limit = 5) => {
    const urlBase = process.env.REACT_APP_API_MAP_URL;
    let allFeatures = [];
    let skip = 0;
    let totalItems = 0;
    let first = true;

    try {
      while (first || allFeatures.length < totalItems) {
        const response = await fetch(
          `${urlBase}/api/v1/provinces?skip=${skip}&limit=${limit}`
        );
        const result = await response.json();

        if (!response.ok) {
          console.error("API error:", result);
          break;
        }
        const { items, total_items } = result;

        if (first) {
          totalItems = total_items;
          first = false;
        }

        allFeatures.push(...items);

        skip += limit; // **skip by limit amount**, not “page number increment**

        // Safety: break if items is empty to avoid infinite loop
        if (!items || items.length === 0) {
          break;
        }
      }

      return {
        type: "FeatureCollection",
        features: allFeatures,
      };
    } catch (err) {
      console.error("Error fetching batches:", err);
      return {
        type: "FeatureCollection",
        features: [],
      };
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, []);
    }, 100);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchUserFormatted(accessToken, setDataUserSurveyorOptions, "13");
      fetchUserFormatted(accessToken, setDataUserSurveyor, "13");
      fetchUserFormatted(accessToken, setDataUserQcOptions, "14");
    }, 100);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  const [mapPosition, setMapPosition] = useState([-2.548, 112.544]);
  const [mapZoom, setMapZoom] = useState(5);

  const zoomToFeature = (feature) => {
    if (!feature) return;

    const bbox = turf.bbox(feature);
    const center = [(bbox[1] + bbox[3]) / 2, (bbox[0] + bbox[2]) / 2];

    const bboxWidth = bbox[2] - bbox[0];
    const bboxHeight = bbox[3] - bbox[1];
    const maxDim = Math.max(bboxWidth, bboxHeight);

    const zoom = Math.floor(10 - Math.log2(maxDim));

    setMapPosition(center);
    setMapZoom(zoom);
  };

  useEffect(() => {
    const getGeoData = async () => {
      const geojson = await fetchGeoJSONDataInBatches(10);

      const updatedGeoJSON = {
        ...geojson,
        features: geojson.features.map((feature) => {
          const provCode = feature.properties.prov_id?.toString();

          const matchingData =
            dashboardData?.filter((d) => d.code === provCode) || [];

          const totalPlanSum = matchingData.reduce(
            (sum, item) => sum + item.total_plan,
            0
          );

          return {
            ...feature,
            properties: {
              ...feature.properties,
              total_plan_sum: totalPlanSum,
              total_plan: totalPlanSum,
            },
          };
        }),
      };

      setFilteredGeoJSONData(updatedGeoJSON);
    };

    if (dashboardData && dashboardData.length > 0) {
      getGeoData();
      const total = dashboardData.reduce(
        (sum, item) => sum + item.total_plan,
        0
      );
      setTotalPlanCount(total);
    }
  }, [dashboardData]);

  const onEachProvinceFeature = (feature, layer) => {
    const provinceName = feature.properties.name;
    const totalPlanSum =
      feature.properties.total_plan_sum || feature.properties.total_plan || 0;

    const tooltip = layer
      .bindTooltip(`${totalPlanSum} Toko`, {
        permanent: true,
        direction: "center",
        className: "province-label",
      })
      .getTooltip();

    layer.on({
      mouseover: () => {
        tooltip.setContent(`${provinceName} (${totalPlanSum} Toko)`);
      },
      mouseout: () => {
        tooltip.setContent(`${totalPlanSum} Toko`);
      },
      click: (e) => {
        zoomToFeature(e.target.feature);
        window.location.href = `/map-surveyor/${feature.properties.prov_id.toString()}?survey_id=${selectedSurveyId}&periode=${selectedPeriodeId}&area=${selectedArea}`;
      },
    });
  };

  const exportToPDF = () => {
    setIsLoading(true);

    const inputElements = document.getElementsByClassName("printToPdfArea");

    if (inputElements.length === 0) {
      console.error('Element with class "printToPdfArea" not found');
      setIsLoading(false);
      return;
    }

    const input = inputElements[0];

    html2canvas(input, { scale: 1.5 })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.7);
        const imgWidth = canvas.width * 0.75;
        const imgHeight = canvas.height * 0.75;
        const pdf = new jsPDF("p", "mm", "a4");

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const title = `peta_sebaran_toko_di_indonesia_0_toko`;

        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(12);

        const titleLines = pdf.splitTextToSize(title, pageWidth - 20);

        let yPosition = 6;
        titleLines.forEach((line) => {
          const textWidth = pdf.getTextWidth(line);
          const xPosition = (pageWidth - textWidth) / 2;
          pdf.text(line, xPosition, yPosition);
          yPosition += 6;
        });

        const imageTopPosition = yPosition + 10;
        const imageHeight = (imgHeight * pageWidth) / imgWidth;

        if (imageHeight <= pageHeight - imageTopPosition) {
          pdf.addImage(
            imgData,
            "JPEG",
            0,
            imageTopPosition,
            pageWidth,
            imageHeight
          );
        } else {
          let heightLeft = imageHeight;
          let position = imageTopPosition;

          while (heightLeft > 0) {
            pdf.addImage(imgData, "JPEG", 0, position, pageWidth, imageHeight);
            heightLeft -= pageHeight;
            if (heightLeft > 0) {
              pdf.addPage();
              position = 0;
            }
          }
        }

        pdf.save(`${title}.pdf`);
      })
      .catch((error) => {
        console.error("Error exporting to PDF:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const MapIcon = (mapData) => {
    let iconUrl = "";

    switch (mapData.store_status) {
      case "0":
        iconUrl =
          "https://img.icons8.com/?size=100&id=7880&format=png&color=FA5252";
        break;
      case "1":
        iconUrl =
          "https://img.icons8.com/?size=100&id=7880&format=png&color=5D9C59";
        break;
      default:
        iconUrl = "default-icon-url.png";
        break;
    }

    const icon = L.icon({
      iconUrl: iconUrl,
      iconSize: [10, 10],
      className: "custom-icon",
    });

    return icon;
  };

  const detailMasterData = (mapData) => {
    return (
      <article>
        <h4>Kode Outlet : {mapData.id}</h4>
        <h4>Nama Outlet : {mapData.name}</h4>
        <h4>Tipe Outlet : {mapData.tipe_toko}</h4>
        <h4>Tipe Survey : {mapData.tipe_survey}</h4>
        <h4>Alamat : {mapData.address}</h4>
      </article>
    );
  };

  const StatusGrid = ({ activeCount, inactiveCount }) => {
    return (
      <div
        style={{
          display: "flex",
          paddingLeft: "3rem",
          textAlign: "left",
          marginTop: "25px",
        }}
      >
        <div>
          <h3>Active: {activeCount}</h3>
          <h3>Inactive: {inactiveCount}</h3>
        </div>
      </div>
    );
  };

  if (notAllowAccessPage) {
    return (
      <div>
        {/* <Navbar
          active="Dashboard"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        /> */}
        <div>Not allow to access this page</div>
      </div>
    );
  }

  return (
    <div className="printToPdfArea">
      {/* <Navbar
        active="Map"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      /> */}
      <div className="content" style={{ padding: "1rem" }}>
        <div className="legend">
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: { xs: "flex-start", sm: "space-between" },
              gap: 2,
              alignItems: "center",
            }}
          >
            <Box sx={{ width: 150 }}></Box>
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: 20,
                    fontFamily: "Montserrat",
                    fontWeight: 700,
                  }}
                >
                  Peta sebaran Toko by Area{" "}
                  {totalPlanCount ? `(${totalPlanCount} Toko)` : ""}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: 12,
                    fontFamily: "Montserrat",
                    fontWeight: 400,
                    textAlign: "center"
                  }}
                >
                  Data yang ditampilkan bersumber dari BPS tahun 2013 (34 Provinsi)
                </Typography>
              </Box>
            <Button
              className="button-pros"
              sx={{
                backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
                border: "1px solid hsl(186, 89.90%, 27.30%)",
                borderRadius: "4px",
                color: "#fff",
                fontSize: "14px",
                height: "fit-content",
                textTransform: "none",
                "&:hover": {
                  backgroundImage: "linear-gradient(#0991a2, #057d8c)",
                },
              }}
              onClick={exportToPDF}
              disabled={isLoading}
            >
              Download as PDF
            </Button>
          </Box>
          <Card sx={{ m: 0.5, mt: 3, backgroundColor: "#f0fbfcff" }}>
            <div>
              {isLoading ? (
                <div>Loading...</div>
              ) : (
                <MapLayout
                  key={JSON.stringify(filteredGeoJSONData)}
                  markersData={{
                    data: surveyDataId,
                    icon: MapIcon,
                  }}
                  position={mapPosition}
                  zoom={mapZoom}
                  pathOptions={{
                    color: "#4f4f4fff",
                    weight: 1,
                    // fillOpacity: 0.7,
                  }}
                  scrollWheelZoom={true}
                  styleContainer={{ width: "100%", height: "700px" }}
                  renderDataDetail={detailMasterData}
                  geoJSONData={filteredGeoJSONData}
                  onEachFeature={onEachProvinceFeature}
                  needLegend={false}
                  needChoropleth={true}
                  styleFeature={styleFeatureWithTotal}
                />
              )}
            </div>
          </Card>
        </div>
      </div>
      <style>{`
        .province-label {
          background-color: transparent;
          border: none;
          box-shadow: none;
          font-weight: 900;
          font-size: 12px;
          color: #333;
            text-shadow: 
                1px 1px 0 white, 
            -1px 1px 0 white, 
                1px -1px 0 white, 
            -1px -1px 0 white; 
            }
      `}</style>
    </div>
  );
}

export default MapSurveyor;
